import { addDays, isAfter, startOfDay } from "date-fns";
import {
	InvalidDeliveryDate,
	InvalidPickupDate,
	ValidDeliveryDate,
	ValidPickupDate,
} from "src/app/server/StoreInfoRequests";
import { formatLocalDate, isSameOrBefore, parseDate } from "../../utils/DateUtil";
import { getDaysToOrderInAdvance } from "../../utils/featureFlagUtil";

type DateInfo = ValidDeliveryDate | ValidPickupDate | InvalidDeliveryDate | InvalidPickupDate;

const isPickupDate = (date: ValidPickupDate | ValidDeliveryDate): date is ValidPickupDate => {
	return (date as ValidPickupDate).pickupTimeSlots !== undefined;
};

export const isValidDay = (
	date: Date,
	info: DateInfo | undefined,
	isPickup: boolean,
	disableDayByTimeSlot: boolean | undefined,
	lastValidDate: string,
) => {
	if (info?.type === "ValidDate") {
		const now = new Date();
		const isNotPastDay = isAfter(date, startOfDay(now));
		const isValid = !isAfter(now, parseDate(info.validUntil)) && isSameOrBefore(date, parseDate(lastValidDate));
		const isLeadTimeCompliant = isAfter(parseDate(info.leadTimeCompliantUntil), now);

		const isTimesSlotValid =
			isPickupDate(info) && info.pickupTimeSlots.some((timeSlots) => timeSlots.availableCapacity > 0);
		if (isPickup) {
			return isNotPastDay && isValid && isLeadTimeCompliant && (disableDayByTimeSlot ? isTimesSlotValid : true);
		} else {
			return isValid;
		}
	}

	return false;
};

export const calculateLastDay = (dateFormat: string) => {
	return formatLocalDate(addDays(new Date(), getDaysToOrderInAdvance()), dateFormat);
};
